/** Centred modal (e4) with a focus trap; Esc closes and focus returns to the invoker. Same behaviour as the Drawer, centred. At 768 px and narrower it is a bottom sheet (dialog.css) and the page behind does not scroll. */
import { useRef, type ReactNode } from "react";
import { useFocusTrap } from "./focusTrap";
import { useScrollLock } from "./GxSheet";
import "./dialog.css";

export function Dialog({ title, lead, onClose, children, footer, testId }: {
  readonly title: string; readonly lead?: ReactNode; readonly onClose: () => void; readonly children?: ReactNode; readonly footer?: ReactNode; readonly testId?: string;
}) {
  const panel = useRef<HTMLDivElement>(null);

  const onKeyDown = useFocusTrap(panel, onClose);
  useScrollLock();

  return (
    <div className="gx-scrim gx-dialog-wrap" onClick={onClose}>
      <div ref={panel} className="gx-dialog" role="dialog" aria-modal="true" aria-label={title} data-testid={testId} onKeyDown={onKeyDown} onClick={(e) => e.stopPropagation()}>
        <div className="gx-dialog-h"><h2 className="gx-h2">{title}</h2>{lead === undefined ? null : <div className="gx-small gx-muted">{lead}</div>}</div>
        {children}
        {footer === undefined ? null : <div className="gx-dialog-f">{footer}</div>}
      </div>
    </div>
  );
}

/** The dialog's Cancel (or Close): always the secondary button, left of the primary action. */
export function DialogCancel({ onClose, label = "Cancel" }: { readonly onClose: () => void; readonly label?: string }) {
  return <button type="button" className="gx-btn gx-btn--secondary" data-testid="dialog.cancel" onClick={onClose}>{label}</button>;
}
